import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import OverTimePresenter from "./OverTimePresenter";
import RequestOvertime from "./RequestOvertime/RequestOvertime";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import DateRangePicker from "../../../components/common/DateRangePicker";
import Progress from "../../../components/Progress";

class OverTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new OverTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      isModalOpen: false,
      objects: [],
      object: {},
      status: [],
      filteredStatus: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const status = await findObjectUseCase().execute("overtime");
    this.setState({ status });
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "filteredStatus") {
      this.onChangeFilter("String", value, "stats");
    }
  }

  getCollectionName() {
    return "overtime";
  }

  // delete function
  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute("overtime", id);
    this.refetchData();
  }

  // edit function
  async handleEditData(object) {
    this.setState({ isModalOpen: true, object, isForViewing: true });
  }

  getCurrent() {
    return this.getCurrentUser();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  handleRequestOvertime() {
    this.setState({ isModalOpen: true, object: {}, isForViewing: false });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Employee Self Service {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-sm-2 mt-1">
                    <SearchSelect
                      value={this.state.filteredStatus}
                      onChange={(value) =>
                        this.onChangeOption("filteredStatus", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredStatus", "")
                      }
                      placeholder="Status"
                      options={[
                        ...["Approved", "Disapproved", "Pending"].map(
                          (item) => ({
                            label: item,
                            value: item,
                          })
                        ),
                      ]}
                    />
                  </div>
                  <div className="col-md-5 mt-1 border-box">
                    <DateRangePicker
                      fields={["dateStarted", "dateEnd", "employee.id"]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>

                  <div className="col-md-5 mt-1 ">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleRequestOvertime.bind(this)}>
                        <i className="bi bi-plus-lg" /> Request {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // indexCount={objects}
                // objectId={this.handleDeleteData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "employee",
                    "remarks",
                    "timeIn",
                    "timeOut",
                    "dateEnd",
                    "dateStarted",
                    "supervisor",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>

          {this.state.isModalOpen && (
            <RequestOvertime
              object={this.state.object}
              isForViewing={this.state.isForViewing}
              closeAccess={this.closeModal.bind(this)}
              refetchData={this.refetchData.bind(this)}
            />
          )}
        </div>
      </>
    );
  }
}

export default withRouter(OverTimePage);
